import { Loading, Page, useApi } from '../components.js';
import { href } from '../router.js';

interface Row { eventId: string; dayId: string; title: string; origin: string; journal: number; media: number; roles: string[]; plannedShots: { total: number; open: number; filmed: number; skipped: number }; flags: string[] }

export function GapsPage({ exp }: { exp: string }) {
  const { data, error } = useApi<{ rows: Row[]; filmedNotJournaled: string[]; summary: Record<string, number> }>(`/api/expeditions/${exp}/gaps`);
  const back = { href: href.expedition(exp), label: 'Expedition' };
  if (!data) return <Page title="Gap list" back={back}><Loading error={error} /></Page>;
  return (
    <Page title="Gap list" back={back}>
      <p className="muted">{Object.entries(data.summary).map(([k, n]) => `${k}: ${n}`).join(' · ')}</p>
      <table>
        <thead><tr><th>Event</th><th>Journal</th><th>Media</th><th>Planned shots</th><th>Flags</th></tr></thead>
        <tbody>
          {data.rows.map((r) => (
            <tr key={r.eventId}>
              <td><a href={href.event(exp, r.eventId)}>{r.eventId} {r.title}</a>{r.origin === 'plan' ? <span className="muted"> · planned</span> : null}</td>
              <td>{r.journal}</td>
              <td>{r.media}{r.roles.length ? <span className="muted"> ({r.roles.join(', ')})</span> : null}</td>
              <td>{r.plannedShots.total ? `${r.plannedShots.filmed}/${r.plannedShots.total} filmed${r.plannedShots.open ? `, ${r.plannedShots.open} open` : ''}` : '–'}</td>
              <td>{r.flags.map((f) => <span key={f} className="flag">{f}</span>)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {data.filmedNotJournaled.length > 0 && <p className="muted">Media not linked to any event: {data.filmedNotJournaled.length} ({data.filmedNotJournaled.slice(0, 20).join(', ')}{data.filmedNotJournaled.length > 20 ? '…' : ''})</p>}
    </Page>
  );
}
